import { render, staticRenderFns } from "./match-card.vue?vue&type=template&id=49e532e2&scoped=true&"
import script from "./match-card.vue?vue&type=script&lang=js&"
export * from "./match-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e532e2",
  null
  
)

export default component.exports